function getConsentPermission() {
    return window.localStorage.getItem('_wb-consent');
}

function setConsentPermission(newValue : boolean){
    window.localStorage.setItem('_wb-consent', String(newValue));
}

function getShowConsentModal() {
    return window.localStorage.getItem('_wb-show-consent-modal');
}

function setShowConsentModal(newValue : boolean){
    window.localStorage.setItem('_wb-show-consent-modal', String(newValue));
}

export default {
    getConsentPermission,
    setConsentPermission,
    getShowConsentModal,
    setShowConsentModal
}
